import React, {useEffect} from 'react'

export const useClickOutside = <T extends HTMLElement = HTMLElement>
(
    isOpen: boolean,
    ref: React.RefObject<T>,
    handler: (event: MouseEvent | TouchEvent) => void,
) => {

    useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            if (!ref) return;
            if (!ref.current || ref.current.contains(event.target as Node)
                || document.getElementById('modal_create-tab')
                || document.getElementById('modal_confirm')
            ) {
                return;
            }
            handler(event);
        };

        if (isOpen) {
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
        }

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler])
}
